import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { Link } from '@jutro/router';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslator } from '@jutro/locale';
import { withRouter } from 'react-router-dom';
import { GatewayEndorsementService as LoadSaveService } from 'twia-capability-gateway-policychange';
import { DateUtil } from '@xengage/gw-portals-util-js';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import messages from './EndorsementConfirmation.messages';
import metadata from './EndorsementConfirmation.metadata.json5';
import styles from './EndorsementConfirmation.module.scss';

function EndorsementConfirmation(props) {
    const { location, history } = props;
    const submissionVM = location?.state?.response;
    const policyNumber = _.get(submissionVM, 'policyNumber') || _.get(submissionVM,'policyChange.policyNumber');
    const referenceNumber = _.get(submissionVM, 'jobID') || _.get(submissionVM,'policyChange.jobID');
    const translator = useTranslator();
    const { authHeader, authUserData } = useAuthentication();
    const [renewalInfo, setRenewalInfo] = useState();
    const [isPolicyChangeForFutureTerm, setIsPolicyChangeForFutureTerm] = useState();
    const isTFPA = authUserData?.associationName_TWIA === 'tfpa';

    const getUrlAndOpen = useCallback(() => {
        const redirectPath = `/policies/${policyNumber}/billing`;
        
        history.push(redirectPath);
    }, [history, policyNumber]);

    const getRenewalInfoUrl = useCallback(() => {
        const redirectPath = `/renewal/${renewalInfo?.renewalJobNumber_TWIA}/summary`;
        
        history.push(redirectPath);
    }, [history, renewalInfo]);
    
    useEffect(()=>{
        if(referenceNumber !== undefined){
            LoadSaveService.getRenewalInfo_TWIA(referenceNumber, authHeader).then((response) => {

                if (response !== null) {
                    setRenewalInfo(response)
    
                    const now = DateUtil.currentDate().getTime();
                    const psDate = _.get(submissionVM, 'baseData.periodStartDate') || _.get(submissionVM,'policyChange.baseData.periodStartDate');
                    const futureTermDate = new Date(psDate.year, psDate.month, psDate.day).getTime() > now
    
                    setIsPolicyChangeForFutureTerm(futureTermDate);
                }
    
            })
        }
    },[])

    const getBillingText = useCallback(() => (
        <span>
            {translator(messages.billingMessage)}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, react/jsx-no-literals */}
            <Link onClick={() => { getUrlAndOpen() }}>
            Policy Billing Page
            {/* eslint-disable-next-line react/jsx-no-literals */}
            </Link>.
        </span>
    ), [getUrlAndOpen, translator]);

    const getRenewalInfoMessage = useCallback(() => (
        <span>
            {translator(isTFPA ? messages.renewalInfoMessage_TFPA : messages.renewalInfoMessage)}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, react/jsx-no-literals */}
            <Link onClick={() => { getRenewalInfoUrl() }}>
            {renewalInfo?.renewalJobNumber_TWIA}
            {/* eslint-disable-next-line react/jsx-no-literals */}
            </Link>.
        </span>
    ), [getRenewalInfoUrl, renewalInfo, translator]);

    const getPolicyNumber = useCallback(() => (
        <span>
            {`${_.get(submissionVM, 'baseData.productName') || _.get(submissionVM, 'policyChange.baseData.productName')} Policy: ${policyNumber}`}
        </span>
    ), [policyNumber, submissionVM]);

    const getReferenceNumber = useCallback(() => (
        <span>
            {`Reference Number: ${referenceNumber}`}
        </span>
    ), [referenceNumber]);


    const overrideProps = {
        policyNumber: {
            content: getPolicyNumber()
        },
        billingPageMessage: {
            content: getBillingText()
        },
        successMessage: {
            content: translator(messages.successMessage)
        },
        renewalInfoMessage:{
            content: getRenewalInfoMessage(),
            visible : ['Draft', 'Quoted', 'Renewing'].includes(renewalInfo?.renewalStatus_TWIA)
                && !_.isUndefined(renewalInfo)
        },
        renewalSchMessage:{
            content : translator(messages.renewalScheduledMessage),
            visible : renewalInfo?.renewalStatus_TWIA === 'Bound' && !isPolicyChangeForFutureTerm
                && !_.isUndefined(renewalInfo)
        },
        referenceNumber: {
            content: getReferenceNumber()
        }
    };

    const goToPolicy = useCallback(() => {
        const redirectPath = `/policies/${policyNumber}/summary`;

        history.push(redirectPath);
    }, [history, policyNumber]);

    const goToEndorsementDetails = useCallback(() => {
        const redirectPath = `/change/${referenceNumber}/summary`;

        history.push(redirectPath);
    }, [history, referenceNumber]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            goToPolicy,
            goToEndorsementDetails
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={submissionVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

EndorsementConfirmation.propTypes = wizardProps;
export default withRouter(EndorsementConfirmation);
